goog.provide("shadow.js.shim.module$src$svg$artwork$cloud_with_files_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$cloud_with_files_svg");
shadow.js.shim.module$src$svg$artwork$cloud_with_files_svg = shadow.js.nativeProvides["src/svg/artwork/cloud-with-files.svg"] = shadow$bridge("src/svg/artwork/cloud-with-files.svg");
module$shadow_js_shim_module$src$svg$artwork$cloud_with_files_svg.default = shadow.js.shim.module$src$svg$artwork$cloud_with_files_svg;
